import { Helper } from '../Helper';
export class GetStorageHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.deleteCacheStorage);
        sb.emitOp(node, 'OVER');
        sb.emitHelper(node, options, sb.helpers.if({
            condition: () => {
                sb.emitOp(node, 'HASKEY');
            },
            whenTrue: () => {
                sb.emitOp(node, 'DROP');
                sb.emitPushBuffer(node, Buffer.alloc(0, 0));
            },
            whenFalse: () => {
                sb.emitHelper(node, options, sb.helpers.cacheStorage);
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitHelper(node, options, sb.helpers.if({
                    condition: () => {
                        sb.emitOp(node, 'HASKEY');
                    },
                    whenTrue: () => {
                        sb.emitOp(node, 'PICKITEM');
                    },
                    whenFalse: () => {
                        sb.emitOp(node, 'NIP');
                        sb.emitHelper(node, options, sb.helpers.getStorageBase);
                    },
                }));
            },
        }));
    }
}

//# sourceMappingURL=GetStorageHelper.js.map
